import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { NavigationRightIcon } from '@icons/NavigationRightIcon'

import { Button } from '@global/button/Button'

import { BasicModal } from '../BasicModal'
import { FromToRangeModalProps } from './FromToRangeModal'
import { FromToRangeModalInputFrom, FromToRangeModalInputTo } from './FromToRangeModalInputs'

import styles from './FromToRangeModal.module.scss'

export const FromToRangeModalDesktop: React.FC<PropsWithChildren<FromToRangeModalProps>> = (
  props
) => {
  const { t } = useTranslation()

  const { size, title, children, fromValue, toValue } = props
  const { renderFooter, onConfirm, onClose } = props
  const isFromValueValid = typeof Number(fromValue) === 'number' && Number(fromValue) >= 0

  return (
    <BasicModal
      title={title}
      size={size}
      renderFooter={({ onClose }) =>
        renderFooter?.({ ...props, onClose }) || [
          <Button.New appearance='secondary' onClick={onClose}>
            {t('Cancel')}
          </Button.New>,
          <Button disabled={!isFromValueValid || !toValue} appearance='primary' onClick={onConfirm}>
            {t('Apply')}
          </Button>,
        ]
      }
      onClose={onClose}
    >
      <div className={styles.inputContainer}>
        <div className={styles.fieldContainer}>
          <FromToRangeModalInputFrom {...props} />
          <NavigationRightIcon />
          <FromToRangeModalInputTo {...props} />
        </div>
        {children}
      </div>
    </BasicModal>
  )
}
